import classNames from 'classnames';
import React from 'react';

import { useCustomSelectContext } from './CustomSelectContext';
import type { CustomSelectOptionProp } from './types';

const CustomSelectOption = ({ className, item, children, ...rest }: CustomSelectOptionProp) => {
    const { value, id, toggleOpen, onValueChange, onKeyDownItem } = useCustomSelectContext();
    return (
        <li
            {...rest}
            id={`selected-${id}-${String(item)}`}
            role="option"
            className="custom-select__option-item"
            aria-selected={String(value) === String(item)}
        >
            <button
                type="button"
                onClick={() => {
                    onValueChange(item);
                    toggleOpen();
                }}
                className="custom-select__option-item-button"
                onKeyDown={(e) => onKeyDownItem(e, item)}
            >
                <span
                    className={classNames(
                        'custom-select_main-content',
                        className ? `${className}__button-main-content` : undefined,
                        {
                            'custom-select__button-main-content--selected': !!value,
                        },
                    )}
                >
                    {children}
                </span>
            </button>
        </li>
    );
};

export default CustomSelectOption;
